import { Modal, ModalBottomButtons } from '@bp/ui-components';
import { observer } from 'mobx-react-lite';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useTimetableStore } from '../TimetableProvider';

export const MathplanInfoModal: FC = observer(() => {
  const { t } = useTranslation();
  const pinboardStore = useTimetableStore();

  return (
    <Modal
      width={'s'}
      title={t('common.hint')}
      isOpen={pinboardStore.solverStore.infoModalOpen}
      onRequestClose={() => pinboardStore.solverStore.setInfoModalOpen(false)}
    >
      <div>{pinboardStore.solverStore.infoModalMessage}</div>
      <ModalBottomButtons
        closeButton={{
          callback: () => pinboardStore.solverStore.setInfoModalOpen(false),
        }}
        submitButton={{
          callback: () => pinboardStore.solverStore.setInfoModalOpen(false),
        }}
      />
    </Modal>
  );
});
